import React from 'react'

export default function Show(props) {
  return props.if ? props.children : null
}
